import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { FadeUp, SectionHead } from "@/components/Reveal";

const CATS = [
    { id: "pants", title: "Signature Pants", sub: "Selvedge, Chino & Active Denim", img: "/img/urwan/2J7A0685.jpg", to: "/shop?cat=pants" },
    { id: "shirts", title: "Signature Shirts", sub: "Vintage Denim & Resort Shirts", img: "/img/urwan/2J7A0616-scaled-e1764148511386.jpg", to: "/shop?cat=shirts" },
    { id: "vintage", title: "Vintage Red", sub: "Occasion wear, office to evening", img: "/img/urwan/DSC00696.jpg", to: "/shop?line=vintage" },
    { id: "active", title: "Active Orange", sub: "Performance for men in motion", img: "/img/urwan/Urwan_01_15.jpg", to: "/shop?line=active" },
];

export default function CategoryCards() {
    return (
        <section className="mx-auto w-full max-w-[1400px] px-5 py-24 md:px-8 md:py-32 lg:px-10">
            <SectionHead eyebrow="The Wardrobe" title="Explore the House" />
            <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-6">
                {CATS.map((c, i) => (
                    <FadeUp key={c.id} delay={i * 0.08}>
                        <Link
                            to={c.to}
                            data-testid={`category-card-${c.id}`}
                            className="group relative block aspect-[3/4] overflow-hidden bg-elev"
                        >
                            <img
                                src={c.img}
                                alt={c.title}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                            <span className="absolute right-4 top-4 grid h-10 w-10 place-items-center border border-white/20 bg-black/40 text-ink backdrop-blur transition-all duration-500 group-hover:bg-gold group-hover:text-black">
                                <ArrowUpRight size={16} />
                            </span>
                            <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                                <p className="text-[10px] font-mono tracking-[0.3em] text-gold">
                                    {String(i + 1).padStart(2, "0")}
                                </p>
                                <h3 className="mt-2 font-display text-lg font-bold uppercase leading-tight text-ink md:text-xl">
                                    {c.title}
                                </h3>
                                <p className="mt-1 hidden text-xs text-mute sm:block">{c.sub}</p>
                                <p className="mt-3 flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-ink">
                                    Discover
                                    <ArrowRight size={12} className="text-gold transition-transform duration-300 group-hover:translate-x-1.5" />
                                </p>
                            </div>
                        </Link>
                    </FadeUp>
                ))}
            </div>
        </section>
    );
}
